//import * as actions from '../../actions/actionTypes';

const initialState = [];

export default function pushAlarmlist(state = initialState, action) {
  switch (action.type) {
    case 'SET_PUSH_ALARM':
      if (action.payload.status) {
        return state; //TODO
      } else if (action.payload) {
        return action.payload;
      } else {
        return state;
      }
    // case 'SET_LOG_ERROR':
    //   return state;
    default:
      return state;
  }
}
